module.exports = __webpack_public_path__ + "static/img/mango-passionfruit-m.60c4844.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/mango-passionfruit-m.jpg
// module id = Fdmo
// module chunks = 0